import type { CacheBackend } from "@pdfking/compatibility"

import { WorkerPool } from "@pdfking/functionpool"
import { KeyDrop } from "@pdfking/tfunc"

import type { APIRequest } from "../types/api/APIRequest"
import type { APIResponse } from "../types/api/APIResponse"
import type { PdfEngine } from "../types/engine/PdfEngine"
import type { PdfEngineOptions } from "../types/engine/PdfEngineOptions"
import type { TrackingInterface } from "../types/tasks/tracking/TrackingInterface"

import { CreateEngineMaster } from "../engine/CreateEngineMaster"

type WorkerEngineOptions = Partial<
  {
    readonly cache: CacheBackend<APIResponse[]>
    readonly worker: string
    readonly workers: number
  } & PdfEngineOptions
>

export const CreateWorkerEngine = (
  config: WorkerEngineOptions = {},
  tracking_interface: TrackingInterface | undefined = undefined
): PdfEngine =>
  CreateEngineMaster(
    KeyDrop(config, ["cache"]),
    forward =>
      WorkerPool<APIRequest, APIResponse>(
        new URL(config.worker ?? "./receiver.js", import.meta.url),
        (config.workers ?? typeof navigator !== "undefined")
          ? navigator.hardwareConcurrency
          : 4,
        forward
      ),
    config.cache,
    tracking_interface
  )
